<template>
    <div v-if="visible">
        <div class="icon" v-if="! expanded" @click="expanded = true">
            <IconAlert height="20" />
        </div>
        <div class="timezone-warning" v-if="expanded">
            <div class="icon" @click="expanded = false">×</div>
            <p>
                {{ $t('forMoscow') }},
                {{ $t('yourTimezone') + $tc('differs', Math.abs(hourOffset)) }}.
            </p>
            <p>{{ $t('example', { n: 13 - hourOffset}) }}</p>
            <p>{{ $t('onlyForText') }}</p>
        </div>
    </div>
</template>

<script>
import IconAlert from '@/components/visual/icons/IconAlert'
export default {
    components: { IconAlert },
    props: [ 'day' ],
    data() {
        return {
            expanded: false,
        }
    },
    computed: {
        visible() {
            return this.hourOffset != 0
        },
        hourOffset() {
            return this.day.getTimezoneOffset() / 60 + 3
        }
    },
}
</script>

<i18n locale="ru" lang="yaml">
    forMoscow: "Текст прогноза написан для московского часового пояса"
    yourTimezone: "а часовой пояс вашего устройства "
    differs: "не отличается | отличается на {n} час | отличается на {n} часа | отличается на {n} часов"
    example: "Например, если в прогнозе написано «После 13 часов желательно...» – для вашего часового пояса это будет значить «После {n} часов желательно...»."
    onlyForText: "Это предупреждение относится ТОЛЬКО к тексту прогноза. Время благоприятности для разных дел (стрижка, маникюр и др.) рассчитано для вашего города и вашего часового пояса."
</i18n>

<i18n locale="ru" lang="yaml">
    hours: ""
</i18n>